/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/ep/close';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17dcf4c9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "card-title flex justify-between",
  id: "card-title-splash"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应用闪屏", -1));
const _hoisted_3 = {
  key: 1,
  class: "splash"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-tips"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传规则"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", null, "*最多允许上传5张闪屏，游戏包闪屏顺序与当前显示顺序一致，拖动缩略图可调整顺序;"), /*#__PURE__*/_createElementVNode("div", null, "*闪屏尺寸将根据手机端屏幕做自适应，小屏手机可能裁剪图片两端。"), /*#__PURE__*/_createElementVNode("div", null, "*必须上传PNG格式的图片;")])], -1));
const _hoisted_5 = {
  class: "marginT10"
};
const _hoisted_6 = {
  class: "img"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["onClick"];
import { apiUsdkGetCommonSplash, apiUsdkSaveSplashNew, apiUsdkSingleGetSplash } from '@/api/usdk';
import draggable from 'vuedraggable';
import { UseComProps } from './hooks';
import Theme from './theme.vue';
import { UseGlobalConfig } from '@/utils/hooks';
import SaveBtn from './saveBtn.vue';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'splash',
  props: {
    ...UseComProps()
  },
  setup(__props) {
    const props = __props;
    const isEdit = ref(false);
    const form = reactive({
      icon_url: []
    });
    let oldForm = ref({
      icon_url: []
    });
    const loading = ref(false);
    /**
     * @description: 获取闪屏
     * @param {*} status 1: 获取渠道闪屏，0: 获取公共闪屏
     * @return {*}
     */
    const getSplash = status => {
      const api = status !== 0 ? apiUsdkSingleGetSplash : apiUsdkGetCommonSplash;
      const params = status !== 0 ? {
        gid: props.gid,
        cid: props.channel.cid
      } : {
        gid: props.gid
      };
      loading.value = true;
      api(params).then(res => {
        if (res.code === 0) {
          // this.lists = res.data || [];
          if (res.data.length) {
            res.data.forEach(item => {
              item.splash && form.icon_url.push({
                url: item.splash
              });
            });
            oldForm.value.icon_url = JSON.parse(JSON.stringify(form.icon_url));
          }
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    watch(() => props.channel, val => {
      if (val) {
        getSplash(props.channel.splash_status);
      }
    }, {
      immediate: true
    });
    const loadingBtn = ref(false);
    const handleClick = type => {
      if (type === 'edit') {
        isEdit.value = true;
      } else if (type === 'cancel') {
        isEdit.value = false;
      } else {
        handleSubmit();
      }
    };
    const handleSubmit = () => {
      loadingBtn.value = true;
      const dict = {
        icon_url: {
          name: '闪屏'
        }
      };
      let params = {
        gid: props.gid,
        cid: props.channel.cid,
        url: form.icon_url.map(item => item.url).join(',')
      };
      const fn = status => {
        apiUsdkSaveSplashNew({
          status,
          ...params
        }).then(res => {
          if (res.code === 0) {
            isEdit.value = false;
            customDataReport({
              eventName: 'set_app_splash',
              dict,
              before: oldForm.value,
              after: form,
              operatePath: '出包-渠道配置-基础配置-应用闪屏',
              gid: props.gid
            });
          }
        }).finally(() => {
          loadingBtn.value = false;
        });
      };
      ElMessageBox.confirm(`你正在编辑修改闪屏，你可以选择将修改后的闪屏一键应用到本游戏的全部渠道，也可仅生效于当前渠道！
          · 一键应用到全部渠道后，本游戏已添加的所有渠道，以及后续新添加的渠道都将使用该闪屏文件
          · 仅修改当前渠道，则对其他渠道无影响`, '提示', {
        customStyle: {
          width: '650px'
        },
        confirmButtonText: '一键应用于全部渠道',
        cancelButtonText: '仅修改当前渠道',
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        fn(0);
      }).catch(action => {
        if (action === 'cancel') {
          fn(1);
        }
      });
    };
    const handleDel = index => {
      if (!isEdit.value) {
        return;
      }
      ElMessageBox.confirm('是否确认删除此闪屏？', '提示').then(() => {
        form.icon_url.splice(index, 1);
      });
    };
    const {
      $channel
    } = UseGlobalConfig();
    onMounted(() => {
      const dom = document.querySelector('#card-title-splash');
      if (!dom) {
        return;
      }
      const isShow = props.channel.plat === 0;
      if (isShow) {
        dom.style.top = '239px';
      } else {
        dom.style.top = '178px';
      }
    });
    return (_ctx, _cache) => {
      var _ctx$channel, _ctx$channel2;
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_el_form_item = __unplugin_components_0;
      const _component_i_ep_close = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      return _openBlock(), _createElementBlock(_Fragment, null, [!((_ctx$channel = _ctx.channel) !== null && _ctx$channel !== void 0 && _ctx$channel.channel.includes(_unref($channel).OFFICIAL_IOS_CHANNEL)) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, !_unref(isEdit) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "btn-color cp",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('edit'))
      }, "[编辑]")) : (_openBlock(), _createBlock(SaveBtn, {
        key: 1,
        loading: _unref(loadingBtn),
        onCancel: handleClick,
        onSave: handleClick
      }, null, 8, ["loading"]))])) : _createCommentVNode("", true), !((_ctx$channel2 = _ctx.channel) !== null && _ctx$channel2 !== void 0 && _ctx$channel2.channel.includes(_unref($channel).OFFICIAL_IOS_CHANNEL)) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_form, {
        model: _unref(form),
        ref: "ruleForm"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "上传闪屏"
        }, {
          default: _withCtx(() => [_createVNode(_component_u_upload, {
            accept: ".png",
            limit: 5,
            timestamp: "",
            showFileList: false,
            modelValue: _unref(form).icon_url,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).icon_url = $event),
            maxSize: 2097152,
            disabled: !_unref(isEdit)
          }, null, 8, ["modelValue", "disabled"]), _hoisted_4]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createVNode(_unref(draggable), {
          group: "people",
          "item-key": "index",
          modelValue: _unref(form).icon_url,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).icon_url = $event)
        }, {
          item: _withCtx(({
            element,
            index
          }) => [_createElementVNode("li", _hoisted_6, [_createElementVNode("img", {
            src: element.url,
            alt: ""
          }, null, 8, _hoisted_7), _createElementVNode("span", {
            class: "close",
            onClick: $event => handleDel(index)
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_i_ep_close)]),
            _: 1
          })], 8, _hoisted_8)])]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["model"])])) : _createCommentVNode("", true), _createVNode(Theme, {
        gid: _ctx.gid,
        channel: _ctx.channel,
        commonInfo: _ctx.commonInfo
      }, null, 8, ["gid", "channel", "commonInfo"])], 64);
    };
  }
});